import { getEnvVariable } from "./utils/generalUtils";

// src/constants.js
export const API_URL = getEnvVariable("VITE_APP_API_HOST_URL") || 'ENV-VAR: VITE_APP_API_HOST_URL is not set';

/**
 * UI authorization gates use JWT authority tuples (scope + subject + action + tenant),
 * mirroring Bad Dog AuthZ.verifyAuthority(). See docs/UI_AUTHORITY_GATING.md and
 * docs/Telescope-Security-Dev-Guide 3.md.
 *
 * Obsolete: VITE_APP_*_ROLE / VITE_APP_*_SCOPE env overrides keyed on rolename.
 */

/** Global tenant provisioning (/dbadmin/*) — GlobalDBA conveys DB Admin / Tenant / CREATE|_ALL */
export const AUTH_GLOBAL_TENANT_PROVISION = {
    scope: 'DB Admin',
    subject: 'Tenant',
    action: 'CREATE',
};

/** Minimum to enter Tenant Administration (SecurityAuditor: READ on security subjects) */
export const AUTH_TENANT_SECURITY_READ = {
    scope: 'Security',
    subject: '_ANY_',
    action: 'READ',
};

/** View/manage user list and user detail (read) */
export const AUTH_TENANT_MANAGE_USERS = AUTH_TENANT_SECURITY_READ;

/** Invite user / add existing user — POST /auth/user, /auth/usertenant */
export const AUTH_TENANT_SECURITY_CREATE = {
    scope: 'Security',
    subject: '_ANY_',
    action: 'CREATE',
};

export const AUTH_TENANT_INVITE_USER = AUTH_TENANT_SECURITY_CREATE;
export const AUTH_TENANT_ADD_EXISTING_USER = AUTH_TENANT_SECURITY_CREATE;

/** Profile edit, role assign/end/reactivate — PUT /auth/user, /auth/userroleperiod */
export const AUTH_TENANT_SECURITY_UPDATE = {
    scope: 'Security',
    subject: '_ANY_',
    action: 'UPDATE',
};

/** Remove user from tenant — DELETE /auth/usertenantbyids */
export const AUTH_TENANT_SECURITY_DELETE = {
    scope: 'Security',
    subject: 'UserTenant',
    action: 'DELETE',
};

export const AUTH_TENANT_REMOVE_USER = AUTH_TENANT_SECURITY_DELETE;

/** Global cross-tenant auth API paths (GlobalSecurityAdmin) */
export const AUTH_GLOBAL_SECURITY_ADMIN = {
    scope: 'Security',
    subject: '_ANY_',
    action: '_ALL',
    requireAnyTenant: true,
};

/** Any global admin tool authority — show Global Administration menu */
export const GLOBAL_ADMIN_AUTHORITIES = [AUTH_GLOBAL_TENANT_PROVISION];

/** Any tenant admin entry authority — show Tenant Administration menu */
export const TENANT_DASHBOARD_AUTHORITIES = [AUTH_TENANT_SECURITY_READ];

export const AUTH_API_URL = getEnvVariable("VITE_APP_AUTH_API_HOST_URL") || 'ENV-VAR: VITE_APP_AUTH_API_HOST_URL is not set';
export const APP_VERSION = getEnvVariable("VITE_APP_VERSION") || "NO APP VERSION";
export const API_VERSION = getEnvVariable("VITE_APP_API_VERSION") || "NO API VERSION";

export function isValidJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
}

// utils.js
export const updateState = (setState, newValue) => {
  setState((prevState) => ({
      ...prevState,
      ...newValue,
  }));
};


export const FaqData = [
  {
    faqid: 1,
    question: "What is a project in Telescope?",
    answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
  },
  {
    faqid: 2,
    question: "How do I ABC?",
    answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
  },
  {
    faqid: 3,
    question: "How do I DEF?",
    answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
  },
  {
    faqid: 4,
    question: "How do I GHI?",
    answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
  },
  {
    faqid: 5,
    question: "How do I JKL?",
    answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
  },
  {
    faqid: 6,
    question: "How do I XYZ?",
    answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
  }
]
